import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39888a78&scoped=true&lang=html&"
import script from "./editAddress.js?vue&type=script&lang=js&"
export * from "./editAddress.js?vue&type=script&lang=js&"
import style0 from "./editAddress.styl?vue&type=style&index=0&id=39888a78&lang=stylus&scoped=true&"
import style1 from "./resetVant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39888a78",
  null
  
)

export default component.exports